import { useContext } from "react";

import { TranslationContext } from "../context/TranslationProvider";

export const useTranslation = () => {
  const dictionary = useContext(TranslationContext);

  const t = (key, params) => {
    if (!dictionary) {
      return key;
    }
    if (!(key in dictionary)) {
      return key;
    }

    let translation = dictionary[key];

    if (params && typeof params === "object") {
      Object.keys(params).forEach((paramKey) => {
        const regex = new RegExp(`\\{${paramKey}\\}`, "g");
        translation = translation.replace(regex, params[paramKey]);
      });
    }

    if (typeof translation === "string") {
      return translation.replace(/\\n/g, "\n");
    }
    return translation;
  };

  return { t };
};
